import classNames from 'classnames';
import Styles from './TabGroup.module.scss';

function TabGroupItem({ icon, name, value, active, onClick }: Readonly<{ icon?: string; name: string; value: number | string; active: boolean; onClick: (val: number | string) => void }>): React.ReactElement {
    const classes = classNames(Styles.tabGroupItem, {
        [Styles.active]: active,
    });

    return (
        <button className={classes} onClick={(_) => onClick(value)}>
            { icon ? <img alt="label" src={'/icons/' + icon} /> : <></> }
            <span>{name}</span>
        </button>
    );
}

function TabGroup({ children }: Readonly<{ children: React.ReactElement[] }>): React.ReactElement {
    return (
        <div className={Styles.tabGroup}>
            {children}
        </div>
    );
}

export {
    TabGroupItem,
    TabGroup,
};
